import * as z from 'zod';
import * as ba from './base';
import { assertVueComponent } from '../helpers';

export interface ReloadGridActionArgs {
  grid: string | string[];
}

export class ReloadGridAction extends ba.Action<ReloadGridActionArgs, any> {
  static get manifest() {
    return {
      name: 'reloadGrid',
      schema: z.object({
        grid: z.union([z.string(), z.array(z.string())]),
      }),
    };
  }

  async handle(event: ba.ActionEvent, args: ReloadGridActionArgs) {
    assertVueComponent(event.component);

    const app = (event.component as any).$app;
    if (app && app.events) {
      app.events.emit('grid:reload', args);
    }
  }
}
